import { render, staticRenderFns } from "./FormSettlementKasbon.vue?vue&type=template&id=07963424"
import script from "./FormSettlementKasbon.vue?vue&type=script&lang=js"
export * from "./FormSettlementKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports